<template>
  <div class="kk-tree__title-container">
    <item
      :id="item.id"
      :depth="depth"
      :is-active="isActive"
      :editable="editable"
      :draggable="false"
      :hash-table="teamsHashTable"
      @save-data="saveData"
    ></item>
    <context-menu v-if="showContextMenu" :item="item" :auth-user="authUser" />
    <horizontal-line v-if="showHorizontalLine" :position="position" />
  </div>
</template>

<script>
import ContextMenu from "./ContextMenu.vue";
import { TreeDefaultNodeIds, Positions } from "../../../../utils/constants";
import HorizontalLine from "../HorizontalLine.vue";
import Item from "../Item.vue";

export default {
  components: { ContextMenu, HorizontalLine, Item },
  props: ["id", "depth", "isActive", "editable"],
  data() {
    return {
      hideTimer: null,
      position: null,
      Positions: Positions,
      startTime: null,
    };
  },
  computed: {
    item() {
      return (this.teamsHashTable && this.teamsHashTable[this.id]) || {};
    },
    teamsHashTable() {
      return this.$store.state.teams.teamsHashTable;
    },
    activeContextMenu() {
      return this.$store.state.activeContextMenu;
    },
    showHorizontalLine() {
      return this.position && this.position !== Positions.Center;
    },
    showContextMenu() {
      // dont show context menu on trash and it's immediate children
      return (
        this.activeContextMenu.id === this.item.id &&
        this.item.id !== TreeDefaultNodeIds.Trash &&
        !(this.item.parents[1] === TreeDefaultNodeIds.Trash && this.item.parents.length === 2)
      );
    },
    authUser() {
      return this.$store.state.authUser;
    },
  },
  methods: {
    saveData(title) {
      this.$store.dispatch("teams/rename", { id: this.item.id, title });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/variables";
.kk-tree__title-container {
  position: relative;
}
</style>
